// extracted by mini-css-extract-plugin
export default {"searchContainer":"InventoryItemsTable_searchContainer__7Vs3r","searchIcon":"InventoryItemsTable_searchIcon__Iiq7t"};